// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const crocodile = defineModel({
  id: "crocodile",
  scale: 2.57, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Crocodile",
  tags: ["creature","crocodile","low-poly","age-of-mcp","future","water"],
  summary: "A crocodile — a wetland and jungle river predator.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.14,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.03, 4), color: "#4c612c", position: [0.05, 0.015, 0.04], rotation: [0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.03, 4), color: "#4c612c", position: [0.05, 0.015, -0.04], rotation: [-0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.03, 4), color: "#4c612c", position: [-0.04, 0.015, 0.04], rotation: [0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.03, 4), color: "#4c612c", position: [-0.04, 0.015, -0.04], rotation: [-0.5, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.16, 0.038, 0.06), color: "#5f7838", position: [0, 0.045, 0] },
      { geometry: new THREE.BoxGeometry(0.16, 0.014, 0.05), color: "#a8b066", position: [0, 0.028, 0] },
      { geometry: new THREE.BoxGeometry(0.085, 0.026, 0.04), color: "#5f7838", position: [0.115, 0.043, 0] },
      { geometry: new THREE.BoxGeometry(0.075, 0.012, 0.036), color: "#4c612c", position: [0.11, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.004, 0.005), color: "#ece8d8", position: [0.115, 0.037, 0.018] },
      { geometry: new THREE.BoxGeometry(0.07, 0.004, 0.005), color: "#ece8d8", position: [0.115, 0.037, -0.018] },
      { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#5f7838", position: [0.07, 0.058, 0.02] },
      { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#5f7838", position: [0.07, 0.058, -0.02] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#d8c84a", position: [0.074, 0.064, 0.02] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#d8c84a", position: [0.074, 0.064, -0.02] },
      { geometry: new THREE.ConeGeometry(0.011, 0.022, 4), color: "#4c612c", position: [0.05, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.01023, 0.02046, 4), color: "#4c612c", position: [0.024, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.00946, 0.01892, 4), color: "#4c612c", position: [-0.002, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.00869, 0.01738, 4), color: "#4c612c", position: [-0.028, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.00792, 0.01584, 4), color: "#4c612c", position: [-0.054, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.00715, 0.0143, 4), color: "#4c612c", position: [-0.08, 0.064, 0] },
      { geometry: new THREE.ConeGeometry(0.00638, 0.01276, 4), color: "#4c612c", position: [-0.106, 0.064, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.03, 0.04), color: "#5f7838", position: [-0.11, 0.042, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.022, 0.028), color: "#5f7838", position: [-0.165, 0.04, 0] },
      { geometry: new THREE.ConeGeometry(0.014, 0.06, 4), color: "#4c612c", position: [-0.215, 0.04, 0], rotation: [0, 0, 1.570796] },
    ],
  animations: [],
});
